module.exports = __webpack_public_path__ + "img/notallowed_ai.e025c329.png";